import React from "react";
import { MemoEditDialogContent, MemoEditDialogStateProvider } from ".";

export const MemoEditDialog = () => {
  return (
    <MemoEditDialogStateProvider>
      <MemoEditDialogContent></MemoEditDialogContent>
    </MemoEditDialogStateProvider>
  );
};
